import { authTheme } from "../../data/auth/authTheme";

export function OnboardingOptionCard({
  title,
  description,
  subtitle,
  icon: Icon,
  selected = false,
  onClick,
  compact = false,
  disabled = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      aria-disabled={disabled}
      className={[
        "flex w-full rounded-xl border bg-white text-left transition",
        compact && Icon
          ? "flex-col items-center gap-3 px-4 py-5"
          : compact
            ? "items-center justify-center px-4 py-5"
            : "items-start gap-4 p-4",
        disabled
          ? "cursor-not-allowed opacity-50"
          : "",
        selected
          ? "border-[#f19500] bg-[#fff9ee] shadow-[0_0_0_1px_#f19500]"
          : "border-[#e5e8f0] hover:border-[#d4d4d8] hover:bg-[#fafafa]",
      ].join(" ")}
    >
      {Icon ? (
        <div
          className={[
            "flex shrink-0 items-center justify-center rounded-xl bg-primary-soft",
            compact ? "size-10" : "size-12",
          ].join(" ")}
        >
          <Icon
            className="h-5 w-5"
            style={{ color: "#9A5B2E" }}
            aria-hidden
          />
        </div>
      ) : null}

      <div className={compact ? "text-center" : "min-w-0 flex-1"}>
        <p
          className={[
            "font-semibold",
            compact ? "text-base" : "text-[15px]",
          ].join(" ")}
          style={{ color: authTheme.heading }}
        >
          {title}
        </p>
        {description ? (
          <p className="mt-1 text-sm leading-6 text-[#6B7280]">{description}</p>
        ) : null}
        {subtitle ? (
          <p className="mt-1 text-[10px] font-semibold uppercase tracking-[1px] text-[#9CA3AF]">
            {subtitle}
          </p>
        ) : null}
      </div>
    </button>
  );
}
